import React from "react";
import css from "./style.scss";
import {withRouter} from "react-router-dom";
import cn from "classnames";

const Tab = (props) => {
  return (
    <button onClick={() => props.onSelect(props.tab)} className={cn(props.className , css.tab, props.selected ? css.selected : "")}>
      {props.children}
    </button>
  )
}
class TabBar extends React.Component {
  constructor(props) {
    super(props)
    let selected = this.props.tabs.slice().reverse().find(t => {
      return this.props.location.pathname.includes(t.path)
    })
    this.state = {
      selected: selected || this.props.tabs[0] || ""
    }
  }

  handleSelect(tab) {
    this.setState({selected: tab})
    this.props.history.replace(tab.path)
  }

  renderTabs() {
    return this.props.tabs.map(tab => {
      return <Tab key={tab.path} className={this.props.className} onSelect={this.handleSelect.bind(this)}
                  selected={this.state.selected.path === tab.path} tab={tab}>{tab.label}</Tab>
    })
  }
  render() {
    return (
      <div className={css.container}>
        {this.renderTabs()}
      </div>
    );
  }
}

export default withRouter(TabBar);



// WEBPACK FOOTER //
// ./src/components/account_page/tabs/index.js